<div *ngFor="let item of items" (click)="$event.stopPropagation()">
  <app-activity-stream-item-host [hostedComponent]="item"></app-activity-stream-item-host>
</div>
